import React from 'react';
import { Modal } from '@leagueplatform/genesis-core';

import { DeleteAccountModal } from './delete-account-modal.component';
import { AccountDeletedModal } from './account-deleted-modal.component';

interface AccountModalsProps {
  onLogout: () => void;
  showDeleteAccountModal: boolean;
  toggleDeleteAccountModal: () => void;
  showAccountDeletedModal: boolean;
  toggleAccountDeletedModal: () => void;
}

export const AccountModals: React.FC<AccountModalsProps> = ({
  onLogout,
  showDeleteAccountModal,
  toggleDeleteAccountModal,
  showAccountDeletedModal,
  toggleAccountDeletedModal,
}) => (
  <>
    <Modal.Root
      open={showDeleteAccountModal}
      onOpenChange={toggleDeleteAccountModal}
    >
      <DeleteAccountModal onDeleted={toggleAccountDeletedModal} />
    </Modal.Root>
    <Modal.Root
      open={showAccountDeletedModal}
      onOpenChange={(open) => {
        if (!open) {
          toggleAccountDeletedModal();
          onLogout();
        }
      }}
    >
      <AccountDeletedModal onClose={onLogout} />
    </Modal.Root>
  </>
);

AccountModals.displayName = 'AccountModals';
